import styled from '@emotion/styled';
import type { DeviceEvent } from '@racemap/sdk/schema/trackers';
import { Tag, Tooltip } from 'antd';
import {
  IconBatteryQuarter,
  IconCar,
  IconLocationPin,
  IconPlug,
  IconPowerOff,
  IconReload,
  IconUnplugged,
  IconWifi,
} from '../Icon';

interface Props {
  activatedDeviceEvents: Array<DeviceEvent>;
}

export const deviceEventDetails: {
  [key in DeviceEvent]: {
    label: string;
    short: string;
    icon: JSX.Element;
    color: string;
  };
} = {
  '+RESP:GTPNA': { label: 'Power On', short: 'PWR_ON', icon: <IconPowerOff />, color: 'green' },
  '+RESP:GTPFA': { label: 'Power Off', short: 'PWR_OFF', icon: <IconPowerOff />, color: 'red' },
  '+RESP:GTEPN': {
    label: 'External Power Connected',
    short: 'EXT_PWR_ON',
    icon: <IconPlug />,
    color: 'green',
  },
  '+RESP:GTEPF': {
    label: 'External Power Disconnected',
    short: 'EXT_PWR_OFF',
    icon: <IconUnplugged />,
    color: 'red',
  },
  '+RESP:GTBPL': {
    label: 'Low Battery',
    short: 'LOW_BATT',
    icon: <IconBatteryQuarter />,
    color: 'orange',
  },
  '+RESP:GTBTC': {
    label: 'Start Charging',
    short: 'CHG_START',
    icon: <IconPowerOff />,
    color: 'green',
  },
  '+RESP:GTSTC': {
    label: 'Stop Charging',
    short: 'CHG_STOP',
    icon: <IconPowerOff />,
    color: 'red',
  },
  '+RESP:GTSTT': {
    label: 'Device State Updated',
    short: 'STATE_UPD',
    icon: <IconReload />,
    color: 'blue',
  },
  '+RESP:GTPDP': {
    label: 'PDP Connection Status',
    short: 'PDP_STAT',
    icon: <IconWifi />,
    color: 'blue',
  },
  '+RESP:GTPNL': {
    label: 'First Location Message',
    short: 'LOC_PWR_ON',
    icon: <IconLocationPin />,
    color: 'blue',
  },
  '+RESP:GTIGN and +RESP:GTIGF': {
    label: 'Ignition Toggle',
    short: 'IGN_TOGGLE',
    icon: <IconCar />,
    color: 'orange',
  },
  '+RESP:GTIGL': {
    label: 'Ignition Location Update',
    short: 'IGN_LOC',
    icon: <IconCar />,
    color: 'blue',
  },
};

export const ActivatedDeviceEvents = ({ activatedDeviceEvents }: Props) => {
  return (
    <Container>
      {activatedDeviceEvents.map((event) => {
        const { label, short, icon, color } = deviceEventDetails[event];

        return (
          <Tooltip key={event} color={color} title={label}>
            <Tag icon={icon} color={color}>
              <Short>{short}</Short>
            </Tag>
          </Tooltip>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  justify-content: flex-end;
`;

const Short = styled.div`
  display: inline-flex;
  align-items: center;
  padding-left: 8px;
`;
